/**
 * logout — signs the user out, clears all state, nukes the fetch cache,
 * signals other tabs via localStorage, and redirects to /login.
 */

/**
 * @param {object} state       - DOMQL root state
 * @param {object} sdk         - SDK instance (flat sdk.logout method)
 * @param {object} queryClient - @symbo.ls/fetch queryClient
 */
export const logout = async (state, sdk, queryClient) => {
  await sdk.logout?.()

  for (const k of Object.keys(state)) state[k] = null
  state.preferences = {}
  state.themeMode = 'auto'
  state.lang = 'en'

  queryClient.clear()
  localStorage.setItem('logout', String(Date.now()))
  localStorage.removeItem('activeOrg')
  localStorage.removeItem('activeWorkspace')
  localStorage.removeItem('activeWorkspaceProject')

  window.history.replaceState(null, '', '/login')
}
